export default "__VITE_ASSET__CPVPphZY__"